"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var withResponsive_1 = require("../decorators/withResponsive");

var withStyles_1 = require("../decorators/withStyles");

var memoize_one_1 = require("@stoplight/memoize-one");

var Tabs_styles_1 = require("./Tabs.styles");

var classNames = require("classnames");

var TabsItem_1 = require("./TabsItem");

var ItemHolder_1 = require("../common/ItemHolder");

var RIGHT_LEFT_DELTA = 8;
var DELTA = 40 + RIGHT_LEFT_DELTA;

var Tabs =
/** @class */
function (_super) {
  __extends(Tabs, _super);
  /* istanbul ignore next */


  function Tabs(props) {
    var _this = _super.call(this, props) || this;

    _this.state = {
      transformWidth: -RIGHT_LEFT_DELTA,
      activeItem: _this.props.activeItem
    };
    _this.tabItemRefs = [];
    _this.ref = null;
    _this.transition = false;
    _this.getItemsWidth = memoize_one_1.default(function (itemRefs, itemsLength) {
      var itemWidths = itemRefs.map(function (item) {
        return item.clientWidth;
      });

      var fullWidth = _this.sumArrayTillIndex(itemWidths);

      return {
        itemWidths: itemWidths,
        fullWidth: fullWidth
      };
    });

    _this.updateItemsPosition = function (index) {
      var _a = _this,
          ref = _a.ref,
          tabItemRefs = _a.tabItemRefs;
      var fluid = _this.props.fluid;
      var width = ref.clientWidth;

      var _b = _this.getItemsWidth(tabItemRefs, tabItemRefs.length),
          itemWidths = _b.itemWidths,
          fullWidth = _b.fullWidth; // текущий активный элемент


      var currentActiveItem = _this.state.activeItem; // текущий значение translate3d:transform

      var currentTransformWidth = _this.state.transformWidth || 0;

      var sumWidthsTillCurrent = _this.sumArrayTillIndex(itemWidths, index);

      var newTransformWidth = sumWidthsTillCurrent;

      if (index >= currentActiveItem) {
        newTransformWidth -= DELTA;
      }

      var currentWidth = itemWidths[index];
      var sumWidths = newTransformWidth + currentWidth;
      var hasEnoughSpaceFromRight = sumWidths - currentTransformWidth + 2 * DELTA <= width; // Если item виден на экране и у него достаточно пустого места с правой стороны, то не двигаем табы

      /* istanbul ignore next line */

      if (index >= currentActiveItem && hasEnoughSpaceFromRight || index < currentActiveItem) {
        newTransformWidth = currentTransformWidth;
      } // Если сумма ширины элементов до текущего (тот который накликан) меньше transform:translateX,
      // то надо двигать внутрь табов (tabs-body) налево


      var isWidthsTillCurrentLessThenTransform = sumWidthsTillCurrent <= DELTA + currentTransformWidth;

      if (index <= currentActiveItem && isWidthsTillCurrentLessThenTransform) {
        newTransformWidth = sumWidths - width + DELTA;
      } // а если ширина transform:translateX получилось больше общей ширины то надо двигать
      // настолько насколько поместуться последные элементы таба


      var newFullWidth = width + newTransformWidth;

      if (newFullWidth >= fullWidth) {
        newTransformWidth = fullWidth - width + RIGHT_LEFT_DELTA;
      } // Если translate3d:transform меньше отступа {DELTA} то надо обнулять его значение
      // потому что в таком случае не надо двигать


      if (newTransformWidth < DELTA && index === 0 || newTransformWidth < 0) {
        newTransformWidth = -RIGHT_LEFT_DELTA;
      }

      if (fluid && width >= fullWidth) {
        newTransformWidth = 0;
      }

      _this.setState({
        transformWidth: newTransformWidth,
        activeItem: index
      }, function () {
        if (!_this.transition) {
          _this.transition = true;
        }
      });
    };

    _this.onItemClick = function (index) {
      return function (e) {
        _this.updateItemsPosition(index);

        _super.prototype.onItemClick.call(_this, index)(e);
      };
    };

    _this.onItemRef = function (index) {
      return function (ref) {
        /* istanbul ignore next line */
        if (ref) {
          _this.tabItemRefs[index] = ref;
        }
      };
    };

    _this.onContainerRef = function (ref) {
      /* istanbul ignore next line */
      if (ref) {
        _this.ref = ref;
      }
    };

    _this.callUpdateItemsPosition = function () {
      _this.updateItemsPosition(_this.state.activeItem);
    };

    props.items.forEach(function (item, index) {
      return item.onRef = _this.onItemRef(index);
    });
    return _this;
  }

  Tabs.prototype.sumArrayTillIndex = function (array, index) {
    var slicedArray = index !== undefined ? array.slice(0, index) : array;
    return slicedArray.reduce(function (sum, el) {
      return sum + el;
    }, 0);
  };

  Tabs.prototype.componentDidMount = function () {
    this.callUpdateItemsPosition();
    window.addEventListener('resize', this.callUpdateItemsPosition, {
      passive: true
    });
  };

  Tabs.prototype.componentWillUnmount = function () {
    window.removeEventListener('resize', this.callUpdateItemsPosition, {
      passive: true
    });
  };

  Tabs.prototype.render = function () {
    var _a;

    var _b = this.props,
        classes = _b.classes,
        fluid = _b.fluid;
    var transformWidth = this.state.transformWidth;
    var bodyClassName = classNames(classes.body, (_a = {}, _a[classes.transition] = this.transition, _a[classes.flexContainer] = fluid, _a));
    return React.createElement("div", {
      className: classes.tabs,
      "data-test-id": "tabs"
    }, React.createElement("div", {
      className: bodyClassName,
      "data-test-id": "tabs-body",
      style: {
        transform: "translateX(" + -transformWidth + "px)"
      },
      ref: this.onContainerRef
    }, this.getItems(this.activeItem(), TabsItem_1.default)));
  };

  Tabs = __decorate([withResponsive_1.withResponsive, withStyles_1.withStyles(Tabs_styles_1.styles)], Tabs);
  return Tabs;
}(ItemHolder_1.default);
/* istanbul ignore next */


exports.default = Tabs;